import type { RouteRecordRaw } from 'vue-router'

const requirementRoutes: RouteRecordRaw[] = [
  {
    path: 'requirements',
    component: () => import('@/views/requirement/RequirementLayout.vue'),
    children: [
      {
        path: '',
        name: 'requirements',
        component: () => import('@/views/requirement/RequirementList.vue')
      },
      {
        path: ':id',
        name: 'requirement-detail',
        component: () => import('@/views/requirement/RequirementDetail.vue')
      }
    ]
  }
]

export default requirementRoutes
